import {Autocomplete, Checkbox, FormControlLabel, Stack, TextField} from "@mui/material";


export interface CLOSProps {
	  disabled?: boolean;
	  required?: boolean;
	  checked: boolean;
	  onCheckedChange: (checked: boolean) => void;
	  checkboxLabel: string;
	  options: string[];
	  textFieldLabel: string;
	  value: string;
	  onOptionSelected: (option: string) => void;
}


export default function APXCheckboxDependentOptionSelector(
		  {disabled = false, checked, onCheckedChange, required = true, checkboxLabel, options, textFieldLabel, value, onOptionSelected}: CLOSProps
) {
	  return (
				 <>
						<Stack direction="row" alignItems="center" justifyContent="center">
							  <FormControlLabel control={<Checkbox/>}
													  label={checkboxLabel}
													  disabled={disabled}
													  checked={checked}
													  onChange={(event) => onCheckedChange(event.target.checked)}
							  />
							  <Autocomplete sx={{ml: 1, width: {xs: "100%", sm: "20%"}}}
												 disabled={/*NOT->*/ !checked}
												 clearOnEscape={false}
												 disableClearable
												 options={options ? options : []}
												 renderInput={(params) => (
															<TextField {...params} required={required} label={textFieldLabel} variant="outlined"
																		  inputProps={{...params.inputProps, readOnly: true}}/>
												 )}
												 value={value}
												 onChange={(event, newValue) => {
														onOptionSelected(newValue);
												 }}
							  />
						</Stack>
				 </>
	  );
}